//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiAccountOutline,
  mdiLogoutVariant,
  mdiLockReset,
  mdiTextBoxEditOutline,
} from '@mdi/js'
import { initialAbility } from '@/plugins/acl/config'
import { computed, getCurrentInstance } from '@vue/composition-api'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@/@core/utils/useCryptoJs'
import store from '@/store'
import Swal from 'sweetalert2'
import { defaultDownloadAppByOS } from '@/@core/utils'

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    showReport: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    confirmButtonText: {
      type: String,
      default: '',
    },
    showQuestion: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy
    const { t } = useUtils()
    const { userData } = useCryptoJs()

    const userAvatar = computed({
      get: () => store.state.auth.userAvatar || JSON.parse(localStorage.getItem('userAvatar')),
      set: value => {
        store.commit('auth/UPDATE_USER_AVATAR', value)
      },
    })

    const logout = () => {
      vm.$ability.update(initialAbility)
      store.dispatch('auth/logoutAction')

      emit('logout')
    }
    const logoutUser = () => {
      if (props.showQuestion) {
        Swal.fire({
          title: props.title,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: props.confirmButtonText,
          cancelButtonText: 'No',
        }).then(async result => {
          if (result.isConfirmed) {
            logout()
          }
        })
      } else {
        logout()
      }
    }

    const resolveUserRoleText = role => {
      if (role === 'subscriber' || role === 'F') return 'Facility'
      if (role === 'author' || role === 'R') return 'Representative'
      if (role === 'maintainer') return 'Maintainer'
      if (role === 'editor') return 'Editor'
      if (role === 'admin' || role === 'A') return 'Administrator'

      return 'Administrator'
    }

    return {
      userData,
      userAvatar,

      logoutUser,
      resolveUserRoleText,
      defaultDownloadAppByOS,
      t,

      icons: {
        mdiAccountOutline,
        mdiLogoutVariant,
        mdiLockReset,
        mdiTextBoxEditOutline,
      },
    }
  },
}
